<template>
  <div v-if="showing">
    <div>
      <modal-mask></modal-mask>
    </div>

    <div class="no-support">
      <div class="version-title">通知</div>
      <div class="discript">当前活动已结束/未开始</div>
      <div class="btn" @click="_close">关闭页面</div>
    </div>
  </div>
</template>

<script>
import appBridge from '@/config/appBridge'
import ModalMask from '@/components/modal/ModalMask'

export default {
  name: 'ActivityOver',

  components: {
    ModalMask
  },
  data () {
    return {
      showing: false
    }
  },
  methods: {
    _close () {
      this.showing = false
      appBridge.closeWebView()
    },
    show () {
      this.showing = true
    }
  }
}
</script>

<style scoped lang="less">
  @import '../../style/mixin';

  .no-support {
    width: 30.7rem;
    height: 15.5rem;
    background-color: @modal-win-bg-color;
    .modal-common;
    /* .modal-anim; */
  }

  .version-title {
    font-size: 1.7rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 2.7rem;
    margin: 2.3rem 0 1.1rem 0;
    text-align: center;
  }

  .title {
    font-size: 1.7rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #841618;
    line-height: 2.4rem;
    position: absolute;
    left: 0;
    right: 0;
    top: 1.3rem;
    text-align: center;
  }

  .discript {
    font-size: 1.3rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ACB4C4;
    line-height: 2.4rem;
    text-align: center;
  }

  .btn {
    font-size: 17px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #00D176;
    height: 4.6rem;
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    line-height: 4.6rem;
    border-top: 1px solid #3B4460;
  }

</style>
